(<template>
  <article class="rejection-reason">
    <div class="comment-label">
      <p>{{ commentText }}</p>
      <p>{{ commentHintText }}</p>
    </div>
    <sk-textarea :preselected-value="comment"
                 :placeholder="commentPlaceholder"
                 :reg-exp="/<\/?[^>]+(>|$)/g"
                 class="request-review__textarea"
                 @fieldvaluechanged="catchComment" />
    <p>{{ wordCountText }}</p>
    <sk-input class="subtask-word-count__input"
              :placeholder="'0'"
              :preselected-value="wordCount"
              :reg-exp="/[^0-9]/g"
              :mob-numeric-keyboard="true"
              :validation-name="wordCountErrorsName"
              @fieldvaluechanged="catchWordCount" />
    <sk-note :text="noteText" />
    <div class="rejection-reason__actions">
      <button class="sk-btn--white"
              @click="closeModal">{{ $gettext('Cancel') }}</button>
      <button class="sk-btn--default"
              @click="saveRequestReview">{{ $gettext('Submit') }}</button>
    </div>
  </article>
</template>)

<script>
  export default {
    props: {
      data: {
        type: Object,
        default() {
          return {};
        }
      }
    },
    data() {
      return {
        comment: '',
        wordCount: '',
        wordCountErrors: [],
        wordCountErrorsName: 'wordCountErrorsName'
      };
    },
    computed: {
      commentText() { return this.$gettext('Comment for project manager'); },
      commentPlaceholder() { return this.$gettext('Write here...'); },
      commentHintText() { return this.$gettext('Optional'); },
      wordCountText() { return this.$gettext('Word count'); },
      modalDescriptionText() { return this.$gettext('Change your deadline proposal while it hasn\'t been reviewed.'); },
      noteText() { return this.$gettext('This word count will be used for invoicing. If it\'s less than 300 words, a flat rate will be used.'); }
    },
    methods: {
      catchComment(value) {
        this.data.context.catchComment(value);
      },
      catchWordCount(value) {
        this.wordCount = value;
        this.data.context.catchWordCount(value);
      },
      closeModal() {
        this.$store.dispatch('ModalStore/closeModal');
      },
      saveRequestReview() {
        if (!this.wordCount) {
          this.wordCountErrors = [];
          this.wordCountErrors.push(this.$gettext('Word count is required for invoices'));
          this.$store.commit('ErrorsStore/setError', {name: this.wordCountErrorsName, errors: this.wordCountErrors});
          return;
        }

        this.data.context.changeStatus('review_requested');
        this.closeModal();
      }
    }
  };
</script>

<style scoped>
p {
  font-size: 12px;
}

button:last-child {
  margin-left: 12px;
}

.comment-label {
  display: flex;
  justify-content: space-between;
  margin-bottom: 2px;
}

.request-review__textarea {
  min-height: 100px;
}
</style>
